/*
 * -------------------------------------------------------------------------
 * IPC通信事件字典
 * -------------------------------------------------------------------------
 * 连接 electron 中的 ipc/dict
 */
export default require('../../../../src/ipc/dict');



// WEBPACK FOOTER //
// ./src/electron/ipc/dict.js